import React from 'react'
import { AlertCircle } from 'lucide-react'

interface ValidationErrorDisplayProps {
  errors: string[]
  title?: string
}

export default function ValidationErrorDisplay({ errors, title = "Please resolve the following issues:" }: ValidationErrorDisplayProps) {
  if (errors.length === 0) return null

  return (
    <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
      <div className="flex items-start space-x-3">
        <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h4 className="text-sm font-medium text-red-800 mb-2">{title}</h4>
          <ul className="text-sm text-red-700 space-y-1">
            {errors.map((error, index) => (
              <li key={index} className="flex items-start">
                <span className="w-1 h-1 bg-red-500 rounded-full mt-2 mr-2 flex-shrink-0"></span>
                {error}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
